import { render, staticRenderFns } from "./CompetitionRegistrations.vue?vue&type=template&id=fc1b6874&scoped=true"
import script from "./CompetitionRegistrations.vue?vue&type=script&lang=js"
export * from "./CompetitionRegistrations.vue?vue&type=script&lang=js"
import style0 from "./CompetitionRegistrations.vue?vue&type=style&index=0&id=fc1b6874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc1b6874",
  null
  
)

export default component.exports